import React from 'react';
import SharedDetails from '../../Components/SharedDetails/SharedDetails';

const columns = [{ title: 'Customer Name', field: 'CustomerName' }];
const csvHeaders = [{ label: 'Customer Name', key: 'CustomerName' }];

const CustomerDetails = () => (
  <SharedDetails
    columns={columns}
    csvFilename="customer-details.csv"
    csvHeaders={csvHeaders}
    emptyMessage="No customer records found."
    pagedEndpoint="/api/get/customer/paged"
    errorMessage="Unable to load customers. Please try again."
    loadingMessage="Loading customers..."
    title="Customer Details"
  />
);

export { CustomerDetails };
export default CustomerDetails;
